import Api from '@/api';

const loadBanner = (context, bannerParams) => Api.homebuyerOffersService
  .getBanner(bannerParams.location)
  .then(response => context.commit('setBanner', response.data));

const loadOffers = (context, offerParams) => Api.homebuyerOffersService
  .getOffers(offerParams.count, offerParams.location, offerParams.referrer)
  .then(response => context.commit('setOffers', response.data));


const trackOfferByAction = (context, offerParams) => Api.homebuyerOffersService
  .postOfferAction(offerParams.action, offerParams.location, offerParams.offer)
  .then(response => context.commit('postOfferAction', response.data));

const getBannerDetails = (context, bannerParams) => Api.homebuyerOffersService
  .getBanner(bannerParams.location)
  .then(response => context.commit('getBanner', response.data));

const trackBannerByAction = (context, bannerParams) => Api.homebuyerOffersService
  .postBannerAction(bannerParams.action, bannerParams.key, bannerParams.location)
  .then(response => context.commit('setTrackBannerByAction', response.data));

export default {
  loadBanner,
  loadOffers,
  trackOfferByAction,
  getBannerDetails,
  trackBannerByAction,
};
